import { List, ListItem, ListItemText, Alert, AlertTitle } from '@mui/material'
import type { AlertColor } from '@mui/material/Alert'
import React from 'react'

type TransferConcern = {
  code: number
  descr: string
}

type TransferConcerns = {
  errors?: TransferConcern[]
  warnings?: TransferConcern[]
}

type ConcernsProps = {
  message: string
  concerns?: TransferConcerns
}

const Concerns: React.FC<ConcernsProps> = ({ message, concerns }) => {
  return (
    <List sx={{ py: 0 }}>
      <Concern severity="error" descr={message} />
      {concerns && (
        <>
          {concerns.errors?.map(({ code, descr }) => (
            <Concern key={code} code={code} severity="error" descr={descr} />
          ))}
          {concerns.warnings?.map(({ code, descr }) => (
            <Concern key={code} code={code} severity="warning" descr={descr} />
          ))}
        </>
      )}
    </List>
  )
}

type ConcernProps = {
  code?: number
  severity: AlertColor
  descr?: string
}

const Concern: React.FC<ConcernProps> = ({ code, severity, descr }) => {
  return (
    <ListItem
      sx={{
        pl: 4,
        pt: 0,
        pb: 0,
      }}
    >
      <ListItemText
        primary={
          <Alert severity={severity} sx={{ mt: 1, mb: 1 }}>
            {code && <AlertTitle>{code}</AlertTitle>}
            {descr}
          </Alert>
        }
      />
    </ListItem>
  )
}

export default Concerns
